<template>

  <header id="SiteTopNav">

    <div class="content">
      <a href="https://fanplayr.com/">
        <img class="brand" src="/logo.svg" >
      </a>
      <!-- <a href="https://fanplayr.com/features/">Features</a>
      <a href="https://fanplayr.com/team/">Team</a>
      <a href="https://fanplayr.com/contact/">Contact</a>
      <a href="https://fanplayr.com/posts/">Blog</a>

      <router-link tag="a" :to="{ path: '/site/login/' }"><span>Login</span></router-link>
      <router-link tag="a" :to="{ path: '/site/register/' }"><span>Register</span></router-link> -->

      <Popper auto-hide placement="bottom-end">
        <div slot="trigger" id="LanguageChooserButton">
          <div :style="{ backgroundImage: `url(https://static.fanplayr.com/portal/assets/img/flags/${getFlag(defaultLanguage)}.svg)` }"></div>
        </div>
        <template #default="{hide}">
          <div id="LanguageChooser" class="site">
            <div
              v-for="lang in supportedLanguages"
              :key="lang.value"
              :value="lang.value"
              :class="{ selected: lang.value === defaultLanguage }"
              @click="chooseLanguage(lang.value, hide)"
              :style="{ backgroundImage: `url(https://static.fanplayr.com/portal/assets/img/flags/${getFlag(lang.value)}.svg)` }"
            >{{ lang.label }}</div>
          </div>
        </template>
      </Popper>

    </div>

  </header>
  
</template>

<script>
export default {
  name: 'SiteTopNav',
  data() {
    return {
      defaultLanguage: 'en'
    }
  },
  async mounted() {
    this.$watch('defaultLanguage', async (newVal) => {

      NProgress.start()
      await this.setLanguage(newVal)

      window.localStorage['portal-language'] = newVal

      NProgress.done()
    })

    const localeGuess = await this.api.getLocaleGuess()
    const langCode = localeGuess && localeGuess.languageCode
    const countryCode = localeGuess && localeGuess.countryCode
    if (langCode && this.supportedLanguages.find(l => l.key)) {
      this.defaultLanguage = langCode
    } else {
      this.defaultLanguage = window.localStorage['portal-language'] || 'en'
    }

    // console.log(countryCode, langCode, this.langCountryMap, this.langCountryMap[langCode] && this.langCountryMap[langCode].includes(countryCode))

    if (countryCode && langCode && this.langCountryMap[langCode] && this.langCountryMap[langCode].includes(countryCode)) {
      window.localStorage['portal-flag'] = JSON.stringify({ [langCode] : countryCode })
    }
  },
  methods: {
    chooseLanguage(lang, hide) {
      this.defaultLanguage = lang
      hide()
    }
  }
}
</script>

<style lang="less">

#SiteTopNav {
  display: flex;
  align-items: center;
  height: 65px;
  background: #fff;
  border-bottom: 1px solid #eee;
  color: #666;
  box-shadow: 0 1px 4px rgba(0,0,0,0.2);
  width: 100%;

  position: fixed;
  right: 0;
  left: 0;
  z-index: 100;
  top: 0;

  @media screen and (max-height: 900px) {
    height: 30px;
  }

  #LanguageChooserButton {
    position: absolute;
    display: flex;
    width: 40px;
    height: 100%;
    margin-right: 15px;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    right: 0px;
    top: 0px;
    cursor: pointer;
    font-size: 1.5em;

    div {
      width: 20px;
      height: 20px;
      background-size: 20px 20px;
      background-repeat: no-repeat;
    }

    &.sNoSuper {
      margin-right: 270px;
    }

    @media screen and (max-width: 780px) {
      display: none;
    }
    @media screen and (max-height: 900px) {
      // margin-right: 265px;
      .fa {
        font-size: 1em;
      }
    }
  }

  .content {
    display: inline-block;
    padding-left: 1em;
    color: #888;
    //font-weight: 300;
    font-size: 20px;
    width: 100%;

    @media screen and (max-height: 900px) {
      font-size: 18px;
    }

    a {
      display: inline-block;
      padding-left: 1.5em;
      color: #888;
      font-weight: 300;

      @media screen and (max-width: 730px) {
        padding-left: .5em;
      }
    }

    img.brand {
      height: 51px;

      @media screen and (max-height: 900px) {
        height: 20px;
      }
    }
  }
}
</style>